import { useState, useEffect, useMemo } from "react"
import { useParams } from "react-router-dom"
import { useVenue } from "providers/venue"
import { getFeatureDetail } from "utils/feature"
import { useDeviceLocation } from "hooks"
import { useLocation } from "react-router-dom"
import config from "config"
import _ from "lodash"

export const useFeatureDetail = () => {
  const { dataLoaded, findFeatureById } = useVenue()
  const [feature, setFeature] = useState(null)
  const { placeId } = useParams()
  const { deviceLocation } = useDeviceLocation()
  const location = useLocation()
  const mobileBaseUrl = config("mobileBaseUrl")

  const placeDetailMobileUrl = useMemo(
    () =>
      `${mobileBaseUrl}${location.pathname}?user-location=${
        _.get(deviceLocation, "id") || ""
      }`,
    [mobileBaseUrl, deviceLocation, location]
  )

  useEffect(() => {
    if (!dataLoaded) return

    const feature = findFeatureById(placeId)
    setFeature(feature)
  }, [dataLoaded, placeId, findFeatureById])
  const featureDetail = useMemo(
    () => getFeatureDetail(feature) || {},
    [feature]
  )
  return { ...featureDetail, feature, dataLoaded, placeDetailMobileUrl }
}
